import React, { useState, useRef, useEffect, useCallback } from "react";
import moment from "moment/moment";
import { FormControl } from "react-bootstrap";
import useClickOutside from "../../../hooks/useClickOutside";

const boxShadowActive = 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6)';
const boxShadowError = 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(225, 80, 70, 0.6)';
const errorContainerStyle = {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -100%)',
    padding: '3px 7px',
    borderRadius: '10px 10px 0 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    fontSize: '1rem',
    color: 'white',
    background: '#EA5353',
}

const errorMessages = {
    interMessed: "Время начала и конца эпизода перепутаны",
    outOfRange: "Время эпизода выходит за пределы зала",
    alreadyTaken: "Эпизод пересекается с другим эпизодом",
}

const getReadFormat = (value) => moment.unix(value).format('HH:mm:ss');
const getStyle = (isError, isActive) => ({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    border: '1px solid',
    borderRadius: 6,
    padding: 2,
    borderColor: isError ? '#EA5353' : isActive ? '#66afe9' : '#ccc',
    boxShadow: isError ? boxShadowError : isActive ? boxShadowActive : 'none',
});

export default ({ value, error = {}, onChange = () => { }, onBlur = () => { } }) => {

    const [isActive, setActive] = useState(false);
    const [timeRange, setTimeRange] = useState(value);

    const isError = Object.keys(error).some(key => error[key]);

    const handleChange = (val, limit) => {
        if (!val) return;

        const [hours, minutes, seconds] = val.split(':');
        let _val = moment.unix(value.start);
        _val.hours(hours);
        _val.minutes(minutes);
        _val.seconds(seconds);
        _val = _val.unix();

        const _timeRange = { ...timeRange };
        _timeRange[limit] = _val;

        onChange(_timeRange);
        setTimeRange(_timeRange);
    }

    const handleResult = useCallback(() => {
        if (isActive) {
            onBlur();
        }
        setActive(false);
    }, [onBlur, isActive]);

    const ref = useClickOutside(handleResult);

    useEffect(() => {
        if (value.start !== timeRange.start || value.end !== timeRange.end) {
            setTimeRange(value);
        }
    }, [value])

    const renderError = () => {
        if (!isError) return null;

        return <div style={errorContainerStyle}>
            {Object.keys(error).map(key => {
                if (error[key]) {
                    return <span key={key} style={{ textAlign: 'center', lineHeight: '1rem' }}>{errorMessages[key]}</span>
                }
            })}
        </div>
    }

    return <div
        ref={ref}
        style={getStyle(isError, isActive)}
        onClick={() => setActive(true)}
    >
        <FormControl
            type="time"
            step="1"
            value={getReadFormat(timeRange.start)}
            onChange={(e) => handleChange(e.target.value, 'start')}
        />
        <span style={{ margin: '0 5px' }}>-</span>
        <FormControl
            type="time"
            step="1"
            value={getReadFormat(timeRange.end)}
            onChange={(e) => handleChange(e.target.value, 'end')}
        />
        {renderError()}
    </div>
}